import { aboutCards, aboutSection } from "./landingContent";
import { LandingCard, LandingSection } from "./LandingPrimitives";

export default function LandingAboutSection() {
  return (
    <LandingSection
      id="visajtech"
      className="landing-section--about"
      eyebrow={aboutSection.eyebrow}
      title={aboutSection.title}
      description={aboutSection.description}
    >
      <div className="landing-about-grid">
        {aboutCards.map((card) => (
          <a
            key={card.title}
            className="landing-about-card-link"
            href={card.href}
            target="_blank"
            rel="noopener noreferrer"
          >
            <LandingCard className="landing-about-card">
              <h3>{card.title}</h3>
              <p>{card.description}</p>
            </LandingCard>
          </a>
        ))}
      </div>

      <div className="landing-about-cta">
        <a
          className="landing-button landing-button--primary"
          href={aboutSection.visajtechUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          <span className="landing-button__label">Mergi pe visajtech.com</span>
        </a>
      </div>
    </LandingSection>
  );
}
